import { useEffect } from 'react';
import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const CTA = dynamic(() => import('common/components/Cta').then(mod => mod.CTA));
const HeroExpertise = dynamic(() =>
  import('modules/expertise/HeroExpertise').then(mod => mod.HeroExpertise),
);
const Strategy = dynamic(() => import('modules/expertise/Strategy').then(mod => mod.Strategy));
const StrategyItems = dynamic(() =>
  import('modules/expertise/StrategyItems').then(mod => mod.StrategyItems),
);

const ExpertisePage = () => {
  const { t } = useTranslation('meta');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seo = {
    alternate: t('expertise.alternate', { returnObjects: true }),
    canonicalSlug: t('expertise.slug'),
    description: t('expertise.description'),
    image: t('expertise.image'),
    slug: t('expertise.slug'),
    title: t('expertise.title'),
  };
  return (
    <Layout dark seo={seo}>
      <HeroExpertise />
      <Strategy />
      <StrategyItems />
      <CTA dark />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IExpertisePageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pageExpertise',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IExpertisePageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default ExpertisePage;
